import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import emailjs, { init } from "@emailjs/browser";
import { useRef, useState } from "react";

import "./Contact.css";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

function Contact() {
  const [firstname, setFirstname] = useState("");
  const [lasname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const form = useRef();

  init("9ybQ5MtfM9f22havr");
  function submit(e) {
    emailjs
      .sendForm(
        "service_es0cpf8",
        "template_1y18l66",
        form.current,
        "9ybQ5MtfM9f22havr"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  }
  return (
    <div>
      <Header />
      <div className="contact__main">
        <section className="contact__main__section__one bgco">
          <h1>Contact us</h1>
        </section>
        <section className="contact__main__section__two">
          <div className="contact__main__section__two__details">
            <h1>Contact details</h1>
            <p>Get in touch with us for any questions about GuineGulf Energy</p>
            <div className="contact__main__section__two__details__block">
              <div>
                <IoMdHome />
                <div>
                  <h1>Office Address</h1>
                  <p>
                    No. 4 Wharf Road, FOT Roundabout, OGFZE Onne, beside Sunway
                    Hotel, Eleme, Rivers State, Nigeria.
                  </p>
                </div>
              </div>
              <div>
                <IoMdMail />
                <div>
                  <h1>Email</h1>
                  <p>info@GuineGulfenergy.com</p>
                </div>
              </div>
              <div>
                <FaPhone />
                <div>
                  <h1>Phone</h1>
                  <p>+2347037593408</p>
                </div>
              </div>
            </div>
          </div>
          <form ref={form} className="contact__main__section__two__send">
            <h1>Send a message</h1>
            <hr />
            <div>
              <input
                placeholder="First Name"
                name="firstname"
                onChange={(e) => {
                  setFirstname(e.target.value);
                }}
              />
              <input
                placeholder="Last Name"
                name="lastname"
                onChange={(e) => {
                  setLastname(e.target.value);
                }}
              />
            </div>
            <div>
              <input
                placeholder="Phone Number"
                name="phone"
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
              />
              <input
                placeholder="Company Name"
                name="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
            <div>
              <input
                placeholder="Message"
                name="message"
                id="contact__main__section__two__send__message"
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
              />
            </div>
            <button
              onClick={(e) => {
                submit();
              }}
            >
              {" "}
              Send now
            </button>
          </form>
        </section>
        <section className="contact__main__section__three">
          <iframe
            src="https://maps.google.com/maps?q=%20No.%204%20Wharf%20Road,%20FOT%20Roundabout,%20OGFZE%20Onne,%20beside%20Sunway%20Hotel,%20Eleme,%20Rivers%20State,%20Nigeria.&t=&z=13&ie=UTF8&iwloc=&output=embed"
            width="600"
            height="450"
            style={{ border: "0", width: "100%" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
